import React from 'react';
import useComposerStore from '../../configurator-composer/composer/composerStore';
import { useTreeNodeManager } from '../scene-editors/hooks/useTreeNodeManager';
import { ComposerAreaNode, ComposerTemplateNode } from './attributes/composerAttributesModels';
import ComposerTemplates from './templates/composerTemplates';

const PredesignTemplateEditor: React.FC = () => {
    const [currentTemplates, currentAreas] = useComposerStore((state) => [state.templates, state.areas]);
    const templateTreeState = useTreeNodeManager<ComposerTemplateNode>(currentTemplates, () => () => null);
    const areaTreeState = useTreeNodeManager<ComposerAreaNode>(currentAreas, () => () => null);
    const designTreeState = useTreeNodeManager<ComposerAreaNode>(currentAreas, () => () => null);
    return <ComposerTemplates templateState={templateTreeState} areaState={areaTreeState} designState={designTreeState} />;
};

export default PredesignTemplateEditor;
